import React from 'react'
import {observer} from 'mobx-react-lite'
import {Box, Text} from '../../../vanilla'
import {actionBoxContainer} from './styles.css'
import {OrderSummary} from '../../../components/order-summary'

interface CartSummaryProps {
  checkoutButtonText: string
  handleCheckoutButtonClick: () => void
  includeBag?: boolean
  setIncludeBag?: (value: boolean) => void
}

const CartSummaryContainer: React.FC<CartSummaryProps> = ({
  checkoutButtonText,
  handleCheckoutButtonClick,
  includeBag,
  setIncludeBag,
}) => {
  return (
    <Box className={actionBoxContainer} bg="white" display={['none', 'block']} alignSelf="stretch">
      <Box
        borderBottom="1px"
        borderColor="gray200"
        padding="16px"
        width="full"
        display={['none', 'block']}
      >
        <Text variant="heading1">Shopping total</Text>
      </Box>
      <OrderSummary
        showItemsCount={false}
        tabledMode={false}
        checkoutButtonText={checkoutButtonText}
        handleCheckoutButtonClick={handleCheckoutButtonClick}
        includeBag={includeBag}
        setIncludeBag={setIncludeBag}
      />
    </Box>
  )
}

export const CartSummary = observer(CartSummaryContainer)
